import { Link } from "react-router-dom";
import type { MediaItem } from "@/types/media";
import { typeLabel } from "@/utils/media";

interface MovieCardProps {
  item: MediaItem;
  index?: number;
}

export default function MovieCard({ item, index = 0 }: MovieCardProps) {
  return (
    <Link
      to={`/detail/${item.id}`}
      className="group flex flex-col overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-all duration-300 hover:-translate-y-1 hover:border-primary-300 hover:bg-primary-50"
      style={{ animation: `fadeInUp 0.5s ease-out ${index * 0.05}s both` }}
    >
      <div className="relative w-full overflow-hidden" style={{ aspectRatio: "2 / 3" }}>
        <img
          src={item.cover}
          alt={`${item.title}封面`}
          title={`${item.title} - 影视详情`}
          className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        <div className="pointer-events-none absolute inset-0 bg-gradient-to-t from-primary-950/70 via-transparent to-transparent" />
        <span className="absolute left-2 top-2 rounded-md bg-primary-900/85 px-2 py-0.5 text-[11px] font-medium text-background-50 backdrop-blur-sm">
          {typeLabel[item.type]}
        </span>
        <span className="absolute right-2 top-2 flex items-center gap-1 rounded-md bg-accent-500 px-2 py-0.5 text-[11px] font-bold text-accent-950">
          <i className="ri-star-fill text-[10px]" aria-hidden="true" />
          {item.rating.toFixed(1)}
        </span>
        <div className="absolute inset-x-0 bottom-0 flex translate-y-2 items-center gap-2 px-2.5 pb-2 opacity-0 transition-all duration-300 group-hover:translate-y-0 group-hover:opacity-100">
          <span className="flex items-center gap-1 rounded-md bg-background-50/95 px-2 py-0.5 text-[11px] font-medium text-primary-800">
            <i className="ri-fire-line text-accent-500" aria-hidden="true" />
            {item.year}
          </span>
          <span className="truncate rounded-md bg-background-50/95 px-2 py-0.5 text-[11px] font-medium text-primary-800">
            {item.region}
          </span>
        </div>
      </div>
      <div className="flex flex-1 flex-col gap-2 p-3">
        <h3 className="truncate font-heading text-sm font-bold text-foreground-950 transition-colors group-hover:text-primary-700 md:text-base">
          {item.title}
        </h3>
        <div className="flex flex-wrap gap-1">
          {item.genres.slice(0, 2).map((genre) => (
            <span
              key={genre}
              className="rounded-md bg-secondary-100 px-1.5 py-0.5 text-[10px] font-medium text-secondary-900"
            >
              {genre}
            </span>
          ))}
        </div>
        <p className="line-clamp-2 text-xs leading-relaxed text-foreground-500">
          {item.synopsis}
        </p>
        <div className="mt-auto flex items-center gap-1 pt-1 text-[11px] text-foreground-400">
          <i className="ri-calendar-line" aria-hidden="true" />
          更新于 {item.updatedAt}
        </div>
      </div>
    </Link>
  );
}